import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;

export async function Definitions(shopUrl,queryType) {
    return axios
    .get(endpoint+'/api/MetaDefinition/owner-types?storeUrl=' + shopUrl + '&queryType=' + queryType)
    .then(function(response) {
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return []
    })
  }

//   export async function DefinitionFields(shopUrl,type) {
//     return axios
//     .get(endpoint+'/api/MetaDefinition/definition-fields?storeUrl=' + shopUrl + '&type=' + type)
//     .then(function(response) {
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return []
//     })
//   }

  export async function downloadDefinitionBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/MetaDefinition/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function definitionBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/MetaDefinition/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function DefinitionBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/MetaDefinition/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteDefinitionLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/MetaDefinition/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getDefinitionImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/MetaDefinition/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function definitionExportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/MetaDefinition/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}
